module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-list"
  }, [_c('ul', _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "help-list__item",
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12696954"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/HelpList.vue
// module id = 536
// module chunks = 0